/** @format */

export const clientAddressEntity = {
    firstname: null,
    mainname: null,
    street: null,
    house: null,
    apartment: null,
    zip: null,
    city: null,
    state: null,
    country: null,
    type: null,
    clientId: null,
    altStateId: 0,
    altBoroughId: 0,
    altDistrictId: 0,
    altCityId: 0,
    altStreetId: 0,
    borough: null,
    district: null,
    nip: null,
};

export const clientAddressEntityStatus = {
    firstname: null,
    mainname: null,
    street: null,
    house: null,
    apartment: null,
    zip: null,
    city: null,
    state: null,
    country: null,
    type: null,
    altStateId: null,
    altBoroughId: null,
    altDistrictId: null,
    altCityId: null,
    altStreetId: null,
    borough: null,
    district: null,
    clientId: null,
    nip: null,
};
